var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "pb-14"
  }, [_c('m-header', {
    attrs: {
      "title": _vm.value.title,
      "breadCrumbs": _vm.breadCrumbs,
      "actions": _vm.isEditingTitle ? [] : _vm.actions
    },
    on: {
      "actionClicked": function actionClicked($event) {
        return $event.exec();
      },
      "alertClicked": function alertClicked($event) {
        return $event.exec();
      }
    },
    scopedSlots: _vm._u([_vm.isEditingTitle ? {
      key: "title",
      fn: function fn() {
        return [_c('v-text-field', {
          staticClass: "mt-1 mb-n1",
          attrs: {
            "label": _vm.$t('common.nouns.title'),
            "outlined": "",
            "loading": _vm.isLoadingTitle,
            "readonly": _vm.isLoadingTitle
          },
          model: {
            value: _vm.editTitleCopy,
            callback: function callback($$v) {
              _vm.editTitleCopy = $$v;
            },
            expression: "editTitleCopy"
          }
        }), _c('div', {
          staticClass: "mt-n6"
        }, [_c('v-btn', {
          staticClass: "mr-1",
          attrs: {
            "x-small": "",
            "elevation": 0,
            "color": "info"
          },
          on: {
            "click": _vm.saveEditTitle
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("save")) + " ")]), _c('v-btn', {
          attrs: {
            "x-small": "",
            "elevation": 0,
            "color": "info",
            "outlined": ""
          },
          on: {
            "click": _vm.cancelEditTitle
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")])], 1)];
      },
      proxy: true
    } : null], null, true)
  }), !_vm.isEditingTitle ? _c('div', {
    staticClass: "mt-n6 mx-4"
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
            attrs = _ref.attrs;
        return [_c('v-chip', _vm._g(_vm._b({
          staticClass: "mr-1",
          attrs: {
            "small": "",
            "color": "info"
          },
          on: {
            "click": _vm.startEditTotal
          }
        }, 'v-chip', attrs, false), on), [_vm._v(" " + _vm._s(_vm.value.total) + " € ")])];
      }
    }], null, false, 1339390141),
    model: {
      value: _vm.isTotalMenu,
      callback: function callback($$v) {
        _vm.isTotalMenu = $$v;
      },
      expression: "isTotalMenu"
    }
  }, [_c('v-card', {
    staticClass: "pt-2",
    attrs: {
      "elevation": 0,
      "loading": _vm.isLoadingTotal
    }
  }, [_c('v-text-field', {
    staticClass: "mx-1 ",
    attrs: {
      "label": _vm.$t('objects.cost.total'),
      "outlined": "",
      "type": "number"
    },
    model: {
      value: _vm.totalCopy,
      callback: function callback($$v) {
        _vm.totalCopy = $$v;
      },
      expression: "totalCopy"
    }
  }), _c('v-card-actions', {
    staticClass: "mt-n5"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "x-small": "",
      "text": ""
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('cancel'))
    },
    on: {
      "click": _vm.abortEditTotal
    }
  }), _c('v-btn', {
    attrs: {
      "x-small": "",
      "text": "",
      "color": "info",
      "loading": _vm.isLoadingTotal
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('save'))
    },
    on: {
      "click": _vm.saveTotal
    }
  })], 1), _c('v-spacer')], 1)], 1)], 1) : _vm._e(), _c('v-divider', {
    staticClass: "mt-2 mb-n4"
  }), _c('m-detail-view-grid', {
    scopedSlots: _vm._u([{
      key: "details",
      fn: function fn() {
        return [_c('v-select', {
          staticClass: "mx-2 mt-2",
          attrs: {
            "item-value": "id",
            "items": _vm.groups,
            "label": _vm.$t('objects.cost.group'),
            "outlined": "",
            "loading": _vm.isLoadingGroup
          },
          on: {
            "change": _vm.saveGroup
          },
          scopedSlots: _vm._u([{
            key: "item",
            fn: function fn(_ref2) {
              var item = _ref2.item;
              return [_vm._v(" " + _vm._s(item.title) + " ")];
            }
          }, {
            key: "selection",
            fn: function fn(_ref3) {
              var item = _ref3.item;
              return [_vm._v(" " + _vm._s(item.title) + " ")];
            }
          }]),
          model: {
            value: _vm.value.group,
            callback: function callback($$v) {
              _vm.$set(_vm.value, "group", $$v);
            },
            expression: "value.group"
          }
        }), _c('v-combobox', {
          staticClass: "mx-2",
          attrs: {
            "label": _vm.$t('objects.cost.tags'),
            "multiple": "",
            "outlined": "",
            "clearable": "",
            "items": _vm.tags
          },
          on: {
            "change": _vm.saveTags
          },
          scopedSlots: _vm._u([{
            key: "selection",
            fn: function fn(_ref4) {
              var item = _ref4.item;
              return [_c('v-chip', _vm._b({
                attrs: {
                  "outlined": ""
                }
              }, 'v-chip', item.attrs, false), [_vm._v(" " + _vm._s(item) + " ")])];
            }
          }, {
            key: "item",
            fn: function fn(_ref5) {
              var item = _ref5.item;
              return [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(item) + " ")])], 1)];
            }
          }]),
          model: {
            value: _vm.value.tags,
            callback: function callback($$v) {
              _vm.$set(_vm.value, "tags", $$v);
            },
            expression: "value.tags"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "mt-1"
  }, [_c('div', {
    staticClass: "mx-2",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('small', {
    staticClass: "ml-1"
  }, [_vm._v(" " + _vm._s(_vm.$t("createdOn", {
    date: _vm.createdDate
  })))]), _c('v-spacer'), !_vm.isEditDescription ? _c('v-btn', {
    attrs: {
      "elevation": 0,
      "text": "",
      "x-small": ""
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('edit'))
    },
    on: {
      "click": _vm.startEditDescription
    }
  }) : _vm._e()], 1), _c('v-textarea', {
    staticClass: "mx-2",
    staticStyle: {
      "height": "180px"
    },
    attrs: {
      "loading": _vm.isLoadingDescription,
      "readonly": !_vm.isEditDescription || _vm.isLoadingDescription,
      "outlined": true
    },
    model: {
      value: _vm.descriptionCopy,
      callback: function callback($$v) {
        _vm.descriptionCopy = $$v;
      },
      expression: "descriptionCopy"
    }
  }), _vm.isEditDescription ? _c('div', {
    staticClass: "mt-n2 mx-2",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "elevation": 0,
      "small": "",
      "color": "info"
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('save'))
    },
    on: {
      "click": _vm.saveEditDesciption
    }
  }), _c('v-btn', {
    attrs: {
      "elevation": 0,
      "small": "",
      "outlined": "",
      "color": "info"
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('close'))
    },
    on: {
      "click": _vm.abortEditDesciption
    }
  })], 1) : _vm._e()], 1), _c('refs-select', {
    staticClass: "mx-2",
    attrs: {
      "partnerId": _vm.value.partnerId,
      "loading": _vm.isLoadingRefs,
      "suggested": [],
      "listMode": false,
      "hideEditButton": false,
      "categories": _vm.refsCategories
    },
    on: {
      "confirm": _vm.saveRefs,
      "change": _vm.saveRefs,
      "input": _vm.saveRefs
    },
    model: {
      value: _vm.value.refs,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "refs", $$v);
      },
      expression: "value.refs"
    }
  }), _c('cost-card-documents', {
    staticClass: "mx-2",
    attrs: {
      "value": _vm.value.files,
      "partnerId": _vm.value.partnerId,
      "costId": _vm.value.id,
      "loading": _vm.isLoadingFiles
    },
    on: {
      "input": _vm.saveFiles
    }
  }), _c('v-divider', {
    staticClass: "mt-2"
  }), _c('activity-card', {
    attrs: {
      "partner": _vm.partner,
      "source": _vm.source,
      "config": {
        comment: true,
        mail: false
      }
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }